import { Component, inject, input, LOCALE_ID, output, signal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PharmacyFileMgt } from '../../../../../services/pharmacy/pharamcy.fileMgt.service';

@Component({
  selector: 'app-pharmacy-license-image',
  imports: [ReactiveFormsModule],
  templateUrl: './pharmacy-license-image.html',
  styleUrl: './pharmacy-license-image.scss',
})
export class PharmacyLicenseImage {
  private pharamcyFileMgt = inject(PharmacyFileMgt);
  private locale = inject(LOCALE_ID);

  pharmacyForm = input.required<FormGroup>();
  uploadSuccess = output<string>();
  selectedImage = signal<File | null>(null);
  imagePreview = signal<string>('');
  validationFormat = signal(false);
  validationSize = signal(false);
  errorUploading = signal('');

  // VALIDATION REQUIRED
  formSubmitted = input<boolean>();
  uploadedFid = signal<string | null>(null);

  processFile(file: File) {
    if (!file.type.match(/image\/(png|jpe?g)|application\/pdf/)) {
      this.validationFormat.set(true);
      // alert($localize`:@@companyFormFileTypeError:Only PNG and JPG files are allowed`);
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      this.validationSize.set(true);
      // alert($localize`:@@companyFormFileSizeError:File ${file.name} exceeds 5MB limit`);
      return;
    }

    this.selectedImage.set(file);

    const reader = new FileReader();
    reader.onload = (e) => {
      this.imagePreview.set(e.target?.result as string);
    };
    reader.readAsDataURL(file);
  }

  onFileSelect(event: Event) {
    this.validationFormat.set(false);
    this.validationSize.set(false);
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    this.processFile(file);

    input.value = '';
    this.onUploadFile();
  }

  onUploadFile() {
    if (this.validationFormat() || this.validationSize()) return;

    this.pharamcyFileMgt.uploadImage(this.selectedImage()!).subscribe({
      next: (res) => {
        this.uploadedFid.set(res.fid);
        this.uploadSuccess.emit(res.fid);
      },
      error: (err) => {
        this.errorUploading.set(
          this.isArabic()
            ? err.messageAr || 'حدث خطأ أثناء الرفع!'
            : err.messageEn || 'some error occured while uploading!',
        );
      },
    });
  }
  isArabic() {
    return this.locale.startsWith('ar');
  }
  isEnglish() {
    return this.locale.startsWith('en');
  }
}
